module.exports = __webpack_public_path__ + "static/img/18.af35472b.png";